import { Injectable } from '@angular/core';
import { UserService } from './shared/user.service';

@Injectable({
  providedIn: 'root'
})
export class RouteBypassService {
  constructor(private userService: UserService) {}
  shouldByPass() {
    const isLoggedIn = this.userService.isLoggedIn();
    if (!isLoggedIn) {
      return true;
    }
    return false;
  }
}
